import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ForgeDividerModule } from "@tylertech/forge-angular";
import { FocusOnLoadDirective } from "../../../../directives/focusOnLoad.directive";
import { MetadataLabelComponent } from "./metadata-label.component";

@Component({
    selector: "metadata-header",
    templateUrl: "./metadata-header.tmpl.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ForgeDividerModule,
        FocusOnLoadDirective,
    ]
})
export class MetadataHeaderComponent extends MetadataLabelComponent
{

}
